import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, ownerOnly = false, platformOnly = false }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505]" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-[#00FF66]" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  if (ownerOnly && !user.is_owner) return <Navigate to="/app" replace />;
  if (platformOnly && !user.platform_owner) return <Navigate to="/app" replace />;
  return children;
}
